import React, { useState } from "react";
import api from "../services/api";
import Header from "../components/Header";
import Footer from "../components/Footer";

const ForgotPassword = () => {

  const [email,setEmail] = useState("");

  const handleSubmit = async (e) => {

    e.preventDefault();

    try {

      const res = await api.post(
        "/auth/forgot-password",
        { email }
      );

      alert("Reset link sent to your email");

    } catch (error) {

      alert(
        error.detail || error.response?.data?.detail || "Failed to send reset email"
      );

    }

  };

  return (

    <div>

      <Header />

      <div style={{maxWidth:"400px",margin:"80px auto"}}>

        <h2>Reset Password</h2>

        <form onSubmit={handleSubmit}>

          <input
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e)=>setEmail(e.target.value)}
            required
          />

          <br/><br/>

          <button type="submit">
            Send Reset Link
          </button>

        </form>

      </div>

      <Footer />

    </div>

  );

};

export default ForgotPassword;